import { useState } from 'react';
import { MdCheck, MdContentCopy, MdShare } from 'react-icons/md';
import { BRAND } from '../utils';

interface Props {
  pedidoId: number;
  onVolver: () => void;
}

export const PantallaExito = ({ pedidoId, onVolver }: Props) => {
  const [copiado, setCopiado] = useState(false);
  const numPedido = String(pedidoId).padStart(6, '0');
  const tieneShare = typeof navigator !== 'undefined' && 'share' in navigator;

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(numPedido);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch { /* clipboard no disponible */ }
  };

  const compartir = async () => {
    try {
      await navigator.share({ title: 'Mi pedido', text: `Pedido #${numPedido} registrado en Almacenes Digitales.` });
    } catch { /* usuario canceló */ }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4 gap-6">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-sm w-full text-center">
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 card-in"
          style={{ backgroundColor: '#DCFCE7', animationDuration: '500ms' }}
        >
          <MdCheck className="text-3xl" style={{ color: '#22C55E' }} aria-hidden="true" />
        </div>

        <h2 className="text-title-3 mb-2" style={{ color: BRAND.navy }}>¡Pedido recibido!</h2>
        <p className="text-muted mb-1">Tu pedido fue registrado.</p>
        <p className="text-muted mb-4">El almacén te contactará para coordinar la entrega.</p>

        <div className="rounded-xl py-3 px-4 mb-4 flex flex-col items-center gap-2" style={{ backgroundColor: '#EAF6FD' }}>
          <span className="text-xs text-gray-500">Número de pedido</span>
          <span className="text-2xl font-bold tracking-widest" style={{ color: BRAND.navy }}>
            #{numPedido}
          </span>
          <div className="flex gap-2">
            <button
              onClick={copiar}
              className="flex items-center gap-1 text-xs px-3 py-1.5 rounded-lg border transition-colors"
              style={{ borderColor: BRAND.cyan, color: copiado ? '#22C55E' : BRAND.cyan }}
              aria-label="Copiar número de pedido"
            >
              {copiado
                ? <MdCheck className="text-sm" aria-hidden="true" />
                : <MdContentCopy className="text-sm" aria-hidden="true" />}
              {copiado ? '¡Copiado!' : 'Copiar'}
            </button>
            {tieneShare && (
              <button
                onClick={compartir}
                className="flex items-center gap-1 text-xs px-3 py-1.5 rounded-lg border transition-colors"
                style={{ borderColor: BRAND.cyan, color: BRAND.cyan }}
                aria-label="Compartir número de pedido"
              >
                <MdShare className="text-sm" aria-hidden="true" />
                Compartir
              </button>
            )}
          </div>
        </div>

        <button onClick={onVolver} className="btn-primary w-full py-2.5 rounded-xl text-sm">
          Volver al catálogo
        </button>
      </div>
    </div>
  );
};
